
import Vue from "vue";
import store from "@/store";
import { convertToPersian } from "@/utils/string";

export default Vue.extend({
  name: "PanelMenu",
  methods: {
    convertToPersian,
    logout(): void {
      store.dispatch("auth/userLogout");
    },
  },
  computed: {
    cartLength(): number {
      return store.state.panel.cart.length;
    },
  },
});
